<template>
  <div class="card text-white bg-primary">
    <div class="card-body">
      <div class="h1 text-muted text-right mb-4">
        <i class="icon-settings"></i>
      </div>
      <div class="text-value">{{ conf }}</div>
      <small class="text-muted text-uppercase font-weight-bold">{{ $t('dashboard.configurations_count') }}</small>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      conf: 0
    }
  },
  mounted () {
    this.getUsersCount()
  },
  methods: {
    getUsersCount () {
      axios.get(`/api/drawer/count`)
      .then(response => {
        this.conf = response.data
      })
    },
  }
}
</script>
